import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import cx from 'classnames';
import { History } from 'history';
import { COMMENT_DELETED } from 'mk/autogenerated/translations/CommentRepliedToMessage.afc9e7f353194325afe21baeb596035d'
import { getForumCommentUrl } from 'mk2/apps/forum/urls';
import { getCommentDisplayAuthor } from 'mk2/apps/forum/utils';
import { RenderSnippetAs } from 'mk2/apps/wiki/utils';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Clamp } from 'mk2/components/Clamp';
import {
    astToHtml,
    defaultFilterAdditionalData,
    FilterAdditionalData,
    ShowPhotosAndVideos,
} from 'mk2/helpers/article_ast/filters';
import { cacheLast } from 'mk2/helpers/cache';
import { scrollElementTo } from 'mk2/helpers/scrolling';
import { BlogPostEntity, CommentEntity, ForumMessageEntity, PostEntity } from 'mk2/schemas';
import React from 'react';
import styles from './CommentRepliedToMessage.mscss';

interface OwnProps {
    clamp: number;
    style: 'dark' | 'light';
    label?: string;
    hasGreyBorder?: boolean;
    repliedToBlogComment?: CommentEntity;
    repliedToForumMessage?: ForumMessageEntity;
    blogPost?: BlogPostEntity;
    forumPost?: PostEntity;
    history: History; // TODO GABO remove question mark
    onRemoveReplyTo?();
}

type Props = OwnProps;

class CommentRepliedToMessage extends React.PureComponent<Props> {

    private astToHtmlCache = cacheLast(true);

    public render() {
        const {
            clamp, hasGreyBorder, label, onRemoveReplyTo, repliedToForumMessage, repliedToBlogComment, style,
            forumPost, blogPost, history,
        } = this.props;

        let Wrapper: React.ElementType = React.Fragment;
        let wrapperProps = {};
        if (forumPost && repliedToForumMessage) {
            const commentId = `comment-${repliedToForumMessage.id}`;
            Wrapper = 'div';
            wrapperProps = {
                onClick: () => {
                    if (document.getElementById(commentId)) {
                        scrollElementTo(`#${commentId}`, 'window-top', 50, true);
                    } else if (history) {
                        // If the comment is not in the DOM, we redirect to the comment URL
                        const gotoUrl = getForumCommentUrl(forumPost, repliedToForumMessage);
                        history.push(gotoUrl);
                    }
                },
            };
            // Wrapper = Link;
            // wrapperProps = { to: getForumCommentUrl(forumPost, repliedToForumMessage) };
        }

        if (blogPost && repliedToBlogComment) {
            const commentId = `#comment-${repliedToBlogComment.id}`;
            Wrapper = 'div';
            wrapperProps = {
                onClick: () => {
                    scrollElementTo(commentId, 'window-top', 50, true);
                },
            };
        }

        const repliedToComment = repliedToForumMessage || repliedToBlogComment;
        return (
            <Wrapper {...wrapperProps}>
                <div
                    className={
                        cx(
                            styles.CommentRepliedToMessage,
                            hasGreyBorder && styles.CommentRepliedToMessage__hasGreyBorder,
                        )
                    }
                >
                    <div className={styles.CommentRepliedToMessage__firstLine}>
                        <div className={styles.CommentRepliedToMessage__user}>
                            {label && (
                                <>
                                    {label}
                                    {' '}
                                </>
                            )}
                            @{getCommentDisplayAuthor(repliedToComment)}
                        </div>
                        {onRemoveReplyTo && (
                            <div className={styles.CommentRepliedToMessage__closeBtn}>
                                <Btn
                                    icon={faTimes}
                                    onClick={onRemoveReplyTo}
                                    type={BtnType.BlackText}
                                />
                            </div>
                        )}
                    </div>
                    <Clamp clamp={clamp}>
                        <div className={styles.CommentRepliedToMessage__message}>
                            {getRepliedToMessageBodyChunks(
                                repliedToComment,
                                style,
                                this.astToHtmlCache,
                            )}
                        </div>
                    </Clamp>
                </div>
            </Wrapper>
        );
    }
}

export default CommentRepliedToMessage;

const getRepliedToMessageBodyChunks = (comment, style, cache) => {
    let bodyChunks: React.ReactChild[] = null;
    if (!comment) {
        return null;
    }
    if (comment.deletedAt) {
        return COMMENT_DELETED;
    }
    if (comment.textAST) {
        const additionalData: FilterAdditionalData = {
            ...defaultFilterAdditionalData,
            showPhotosAndVideos: ShowPhotosAndVideos.NONE,
            renderSnippetObjectsAs: RenderSnippetAs.PLAIN_LINK,
            renderSpecialWikiLinks: false,
            customStyles: {
                paragraph: styles[`CommentRepliedToMessage__paragraph--${style}`],
                mention: styles[`CommentRepliedToMessage__mention--${style}`],
            },
            rootDiv: false,
        };
        bodyChunks = cache(() => astToHtml(comment.textAST, additionalData), comment.textAST);
    }
    return bodyChunks;
};
